<a
    class="resource-browse-card gtm-results-browse-card selenium-resource-browse-card"
    [attr.data-gtmlabel]="learningObject.title"
    [attr.data-gtmresultindex]="gtmDataCardNumber"
    [ngClass]="getCardType()"
    [routerLink]="learningObject.routerLink"
>
    <app-language-badge [languages]="learningObject.languages"></app-language-badge>
    <div class="header">
        <app-resource-card-poster
            class="thumbnail"
            [posterImage]="
                learningObject.getPosterImage(getPosterImageWidth(), getPosterImageHeight())
            "
            [duration]="learningObject.duration"
            [gtmPrefix]="gtmPrefix"
            [title]="learningObject.title"
            [mediaType]="getMediaType()"
            [absoluteUrl]="learningObject.canonicalUrl"
            [gtmDataCardNumber]="gtmDataCardNumber"
        >
        </app-resource-card-poster>
    </div>
    <div class="content">
        <span
            [attr.aria-label]="learningObject.title ? 'Open ' + learningObject.title : null"
            [class]="getResourceBodyClass()"
            [attr.data-gtmlabel]="learningObject.canonicalUrl"
        >
            <app-card-title [height]="titleHeight()">
                <span [innerHtml]="learningObject.title"></span>
            </app-card-title>
        </span>
        <app-card-description *ngIf="!isMediumCard()"
            ><span [innerHtml]="learningObject.description | safeTruncate: truncateSize()"></span>
        </app-card-description>
        <app-browse-card-meta
            [supportMaterialsCount]="learningObject.supportMaterials.length"
            [supportMaterialsLink]="learningObject.routerLink"
            [contentProject]="learningObject.project"
            [gradeRange]="learningObject.gradeRanges"
            [brand]="learningObject.brand"
            [gtmDataCardNumber]="gtmDataCardNumber"
        ></app-browse-card-meta>
    </div>
</a>
